import React from 'react'
import css from './style.scss'
import cn from 'classnames'
import {Link} from 'react-router-dom'


const Button=(props)=>{
  let classes=cn(
    css.button,
    props.primary ? css.primary : "",
    props.inline ? css.inline : "",
    props.fullWidth ? css.fullWidth : "",
    props.inline_primary ? css.inline_primary : "",
    props.small ? css.small : "",
    props.disabled ? css.disabled : "",
    props.className
  )
  if(props.type==="submit"){
    return(
      <button className={classes}>
        {props.children}
      </button>
    )
  }
  if(props.to){
    return(
      <Link className={classes} to={props.to}>
        {props.children}
      </Link>
    )
  }else{
    return(
      <button className={classes} onClick={props.onClick}>
        {props.children}
      </button>
    )
  }
}

export default Button;



// WEBPACK FOOTER //
// ./src/components/shared/button/index.js